'use es6';

import Client from 'AdsUI/data/Client';
import { CompanyListTypes } from 'AdsUI/lib/Constants';
const baseUrl = `ads/v1/audience`;
const pixelBaseUrl = `ads/v1/pixel`;
const savedAudiencesBaseUrl = 'ads/v1/savedAudiences';
export const getAudiences = () => {
  return Client.apiRequest(baseUrl);
};
export const getSyncedContactLists = () => {
  return Client.apiRequest(`${baseUrl}/synced-contact-lists`);
};
export const getCompanyListCounts = (companyListType, companyListId) => Client.apiRequest(`${baseUrl}/company-lists/type/${companyListType}${companyListType === CompanyListTypes.COMPANY_LIST ? `/${companyListId}` : ''}/count`);
export const getPixels = ({
  includeOnlyInstalled
}) => {
  return Client.apiRequest(`${pixelBaseUrl}`, {
    query: {
      includeOnlyInstalled
    }
  });
};
export const getAudienceActiveCounts = () => Client.apiRequest(`${baseUrl}/active-counts`);
export const getInactiveAudiences = () => Client.apiRequest(`${baseUrl}/inactive`);
export const getAudienceToSForAccount = ({
  adNetwork,
  accountId,
  audienceSource
}) => {
  return Client.apiRequest(`${baseUrl}/${adNetwork.toLowerCase()}/tos`, {
    query: {
      accountId,
      audienceSource
    }
  });
};
export const getAudienceToSStatus = ({
  adNetwork,
  accountId,
  audienceSource
}) => {
  return Client.apiRequest(`${baseUrl}/${adNetwork.toLowerCase()}/tos-status`, {
    query: {
      accountId,
      audienceSource
    }
  });
};
export const getAccountsWithUnacceptedToS = ({
  adNetwork,
  audienceSource
}) => {
  return Client.apiRequest(`${baseUrl}/${adNetwork.toLowerCase()}/tos/unaccepted`, {
    type: 'GET',
    query: {
      audienceSource
    }
  });
};
export const acceptAudienceToSForAccounts = ({
  audienceSource,
  adNetworkAccountIdsMap
}) => {
  return Client.apiRequest(`${baseUrl}/tos`, {
    type: 'POST',
    query: {
      audienceSource
    },
    data: adNetworkAccountIdsMap
  });
};
export const createPixel = ({
  adNetwork,
  accountId
}) => {
  return Client.apiRequest(`${pixelBaseUrl}/${adNetwork.toLowerCase()}/account/${accountId}`, {
    type: 'POST'
  });
};
export const installPixel = ({
  adNetwork,
  accountId,
  id
}) => {
  return Client.apiRequest(`${pixelBaseUrl}/${adNetwork.toLowerCase()}/account/${accountId}/pixel/${id}`, {
    type: 'POST'
  });
};
export const createRuleBasedAudience = query => {
  return Client.apiRequest(`${baseUrl}/rule-based`, {
    type: 'POST',
    data: Object.assign({}, query)
  });
};
export const createContactListAudience = ({
  adNetwork,
  contactListId,
  accountId,
  audienceName,
  description,
  immediatelyMarkContactsMarketable
}) => {
  return Client.apiRequest(`${baseUrl}/contact-list`, {
    type: 'POST',
    data: {
      adNetwork,
      accountId,
      name: audienceName,
      contactListId,
      description,
      immediatelyMarkContactsMarketable
    }
  });
};
export const createCompanyListAudience = ({
  adNetwork,
  companyListId,
  companyListType,
  accountId,
  audienceName,
  description
}) => {
  return Client.apiRequest(`${baseUrl}/company-list`, {
    type: 'POST',
    data: {
      adNetwork,
      accountId,
      name: audienceName,
      companyListType,
      companyListId,
      description
    }
  });
};
export const createEngagementAudience = ({
  adNetwork,
  pageId,
  audienceSourceApp,
  accountId,
  name,
  description
}) => {
  return Client.apiRequest(`${baseUrl}/automatic-engagement`, {
    type: 'POST',
    data: {
      adNetwork,
      accountId,
      name,
      pageId,
      audienceSourceApp,
      description
    }
  });
};
export const deleteAudience = audienceId => {
  return Client.apiRequest(`ads/v1/audience/delete/${audienceId}`, {
    type: 'DELETE'
  });
};
export const createLookalikeAudience = ({
  adNetwork,
  accountId,
  name,
  description,
  seedTargetingAudienceId,
  countries
}) => {
  return Client.apiRequest(`${baseUrl}/lookalike`, {
    type: 'POST',
    data: {
      adNetwork,
      accountId,
      name,
      description,
      seedTargetingAudienceId,
      countries
    }
  });
};
export const getSupportedAudiences = (adNetwork, adAccountId) => {
  return Client.apiRequest(`${baseUrl}/${adNetwork.toLowerCase()}/${adAccountId}/supported`);
};
export const getFacebookSavedAudiences = adAccountId => {
  return Client.apiRequest(`${savedAudiencesBaseUrl}/facebook/${adAccountId}`);
};
export const getMembershipCounts = listId => {
  return Client.apiRequest(`${baseUrl}/lists/${listId}/membership-counts`);
};
export const getMembershipCountsInboundDB = listId => {
  return Client.apiRequest(`${baseUrl}/object-lists/${listId}/membership-counts`);
};
export const getMembershipCountsByAudienceId = targetingAudienceId => {
  return Client.apiRequest(`${baseUrl}/${targetingAudienceId}/membership-counts`);
};
export const deleteContactsFromList = (audienceId, vids) => Client.apiRequest(`${baseUrl}/contact-list/${audienceId}/membership/remove/batch`, {
  type: 'POST',
  data: vids
});
export const getLinkedInFacetForLookalikeAudience = (adAccountId, audienceId) => Client.apiRequest(`${baseUrl}/linkedin/${adAccountId}/lookalike/${audienceId}/ad-targeting-facet`);
export const getAudienceAdSequences = audienceId => Client.apiRequest(`${baseUrl}/${audienceId}/ad-sequence-statuses`);